import { Type } from "../type";

export const productUpdateMutations = {
  [Type.PRODUCT_UPDATE_SUCCESS](state, payload) {
    let targetIndex = state.productList.findIndex(
      (product) => product.id == payload.id
    );
    state.productList[targetIndex] = payload.data;
  },
  [Type.PRODUCT_UPDATE_FAILURE](state, payload) {
    console.log(payload);
  },
};
